var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowbattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,27.94H30.75a2.61,2.61,0,0,0,2.61-2.61V23.86a.87.87,0,0,1,.87-.87h0a.88.88,0,0,0,.88-.87h0V17.76a.87.87,0,0,0-.87-.87h0a.87.87,0,0,1-.88-.87h0v-.48a3.48,3.48,0,0,0-3.48-3.48H8.38a3.48,3.48,0,0,0-3.49,3.48v9.78A2.61,2.61,0,0,0,7.5,27.94Zm0-1.74a.86.86,0,0,1-.87-.87h0V15.54A1.74,1.74,0,0,1,8.38,13.8h21.5a1.74,1.74,0,0,1,1.74,1.74v9.78a.89.89,0,0,1-.87.88H7.51Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.87,
    y: 14.74,
    width: 3.92,
    height: 10.56,
    rx: 0.77
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowbattery);
export default __webpack_public_path__ + "static/media/lowbattery.8fd29fff1cc085e29b53782818f6420f.svg";
export { ForwardRef as ReactComponent };